/**
 * Collection Manager Review Queue V1 API permissions (design §9).
 */

export const COLLECTION_MANAGER_REVIEW_ACKNOWLEDGE_PERMISSION =
  'collection_manager_review:acknowledge' as const;

export const COLLECTION_MANAGER_REVIEW_DEFER_PERMISSION =
  'collection_manager_review:defer' as const;

export const COLLECTION_MANAGER_REVIEW_PERMISSIONS = [
  COLLECTION_MANAGER_REVIEW_ACKNOWLEDGE_PERMISSION,
  COLLECTION_MANAGER_REVIEW_DEFER_PERMISSION,
] as const;

export type CollectionManagerReviewPermission =
  (typeof COLLECTION_MANAGER_REVIEW_PERMISSIONS)[number];

export function isCollectionManagerReviewPermission(
  permission: string
): permission is CollectionManagerReviewPermission {
  return (COLLECTION_MANAGER_REVIEW_PERMISSIONS as readonly string[]).includes(permission);
}
